import script from "./FloatingHelpButton.vue?vue&type=script&setup=true&lang=js"
export * from "./FloatingHelpButton.vue?vue&type=script&setup=true&lang=js"

import "./FloatingHelpButton.vue?vue&type=style&index=0&id=441b4abe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-441b4abe"]])

export default __exports__